import { translationKeyExists } from "../translations";
import { isArray, isSomething } from "../utils/langUtils";
import { handleUnknownErrors } from "../utils/errorUtils";

import ApiError from "./ApiError";

import { showError } from "../utils/notificationUtils";

const UNKNOWN_ERROR_KEY = "api.error.unknown";

export function extractCommonApiError(
  error: $TSFixMe,
  mappings: $TSFixMe,
  request: $TSFixMe,
) {
  let errorKey = `api.error.${error.type}`;

  if (mappings && mappings[error.type]) {
    errorKey = `api.error.${mappings[error.type]}`;
  }

  if (translationKeyExists(errorKey)) {
    return errorKey;
  }
  // @ts-expect-error TS(2554) FIXME: Expected 2 arguments, but got 1.
  handleUnknownErrors({ error, request });
  return UNKNOWN_ERROR_KEY;
}

export function extractCommonApiErrors(errors: $TSFixMe, mappings: $TSFixMe) {
  if (errors) {
    let commonErrors;
    if (
      errors.filter((error: $TSFixMe) => error.attribute === "captcha").length >
      0
    ) {
      commonErrors = errors
        .filter((error: $TSFixMe) => error.attribute)
        .map((error: $TSFixMe) =>
          extractCommonApiError(error, mappings, errors.request),
        );
    } else {
      commonErrors = errors
        .filter((error: $TSFixMe) => !error.attribute)
        .map((error: $TSFixMe) =>
          extractCommonApiError(error, mappings, errors.request),
        );
    }
    // sadly IE doe not get it when using fancy spread operator, so lets do it the old school way
    // return [...new Set(commonErrors)]
    const errorSet = new Set(commonErrors);
    const errorArray: $TSFixMe = [];
    errorSet.forEach((v) => errorArray.push(v));
    return errorArray;
  }
  return [];
}

export function extractAttributeApiError(error: $TSFixMe) {
  const errorKey = `api.error.${error.attribute}.${error.type}`;
  if (translationKeyExists(errorKey)) {
    return errorKey;
  }
  // @ts-expect-error TS(2554) FIXME: Expected 2 arguments, but got 1.
  handleUnknownErrors(error);
  return UNKNOWN_ERROR_KEY;
}

export function handleCommonApiErrors(
  props: $TSFixMe,
  nextProps: $TSFixMe,
  mappings: $TSFixMe,
) {
  const { errors, intl } = nextProps;
  if (errors && errors !== props.errors) {
    if (isArray(errors)) {
      // @ts-expect-error TS(7006) FIXME: Parameter 'error' implicitly has an 'any' type.
      extractCommonApiErrors(errors, mappings).forEach((error) => {
        showError(intl.formatMessage({ id: error }));
      });
    } else {
      handleUnknownErrors(
        errors,
        intl.formatMessage({ id: "api.error.unknown" }),
      );
    }
  }
}

export function handleApiErrors(
  callback: $TSFixMe,
  props: $TSFixMe,
  nextProps: $TSFixMe,
  typeMappings: $TSFixMe,
) {
  handleCommonApiErrors(props, nextProps, typeMappings);
  if (callback) {
    callback.resolve();
  }
}

export function assignApiAttribute(
  errors: $TSFixMe,
  type: $TSFixMe,
  attribute: $TSFixMe,
) {
  if (isArray(errors)) {
    const mappedErrors: $TSFixMe = [];
    errors.forEach((error: $TSFixMe) => {
      if (error.type === type) {
        mappedErrors.push({ ...error, attribute });
      } else {
        mappedErrors.push(error);
      }
    });
    return mappedErrors;
  }
  return errors;
}

export function mapApiErrorType(
  errors: $TSFixMe,
  type: $TSFixMe,
  newType: $TSFixMe,
) {
  if (isArray(errors)) {
    const mappedErrors: $TSFixMe = [];
    errors.forEach((error: $TSFixMe) => {
      if (error.type === type) {
        mappedErrors.push({ ...error, type: newType });
      } else {
        mappedErrors.push(error);
      }
    });
    return mappedErrors;
  }
  return errors;
}

export function mapApiAttributes(errors: $TSFixMe, attribute: $TSFixMe) {
  if (isArray(errors)) {
    const mappedErrors: $TSFixMe = [];
    errors.forEach((error: $TSFixMe) => {
      if (error.attribute) {
        mappedErrors.push({ ...error, attribute });
      } else {
        mappedErrors.push(error);
      }
    });
    return mappedErrors;
  }
  return errors;
}

export function ignoreInvalidInputError(errors: $TSFixMe) {
  if (isArray(errors)) {
    return errors.filter((e: $TSFixMe) => e.type !== "invalid_input");
  }
  return errors;
}

export function ignoreServiceUnavailable(errors: $TSFixMe) {
  if (isArray(errors)) {
    return errors.filter((e: $TSFixMe) => e.type !== "service_unavailable");
  }
  return errors;
}

export function isNotFoundError(errors: $TSFixMe, ignoreOthers = true) {
  return (
    errors &&
    isArray(errors) &&
    isSomething(
      errors.find((e: $TSFixMe) => e.type === "not_found_no_permission"),
    ) &&
    (ignoreOthers || errors.length === 1)
  );
}

// used only in test / can remove
export function removeApiAttributes(errors: $TSFixMe, attribute: $TSFixMe) {
  const mappedErrors: $TSFixMe = [];
  if (isArray(errors)) {
    errors.forEach((error: $TSFixMe) => {
      if (error.attribute === attribute) {
        mappedErrors.push({ type: error.type, message: error.message });
      } else {
        mappedErrors.push(error);
      }
    });
    return mappedErrors;
  }
  return errors;
}

export function combineErrors(errors: $TSFixMe) {
  // @ts-expect-error TS(2554) FIXME: Expected 2 arguments, but got 0.
  const combinedErrors = new ApiError();
  errors.forEach((values: $TSFixMe) => {
    if (isSomething(values)) {
      values.forEach((value: $TSFixMe) => combinedErrors.push(value));
    }
  });

  if (combinedErrors.length > 0) {
    return combinedErrors;
  }

  return null;
}

export function apiErrorsContain(
  errors: $TSFixMe,
  type: $TSFixMe,
  attribute = null,
) {
  if (isArray(errors)) {
    if (attribute) {
      return isSomething(
        errors.find(
          (error: $TSFixMe) =>
            error.type === type && error.attribute === attribute,
        ),
      );
    }
    return isSomething(errors.find((error: $TSFixMe) => error.type === type));
  }
  return false;
}
